import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const card = {
  background: 'rgba(30,45,79,0.5)',
  borderRadius: '16px',
  border: '1px solid rgba(0,194,168,0.1)',
  padding: '24px',
};

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div style={{ background:'#1E2D4F', border:'1px solid rgba(0,194,168,0.3)', borderRadius:'8px', padding:'12px 16px' }}>
      <div style={{ fontFamily:'Space Grotesk', fontSize:'12px', color:'#5B7BA8', marginBottom:'8px' }}>{label}</div>
      {payload.map(p => (
        <div key={p.name} style={{ fontFamily:'JetBrains Mono', fontSize:'13px', color: p.color, display:'flex', justifyContent:'space-between', gap:'16px' }}>
          <span>{p.name}</span><span style={{ fontWeight:600 }}>{p.value.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}

export default function TimelineChart({ data }) {
  if (!data || data.length === 0) return null;

  const formatted = data.map(d => ({
    ...d,
    week: d.week,
    Pass: d.pass,
    Fail: d.total - d.pass,
  }));

  return (
    <div style={card}>
      <div style={{ marginBottom:'20px' }}>
        <div style={{ fontFamily:'Space Grotesk', fontWeight:600, fontSize:'16px', color:'#F0F4FF' }}>
          Email Authentication Trend
        </div>
        <div style={{ fontFamily:'Inter', fontSize:'12px', color:'#5B7BA8', marginTop:'4px' }}>
          Weekly DMARC pass/fail volume
        </div>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={formatted} margin={{ top:5, right:5, bottom:5, left:0 }}>
          <defs>
            <linearGradient id="passGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#00C2A8" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#00C2A8" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="failGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#E8415A" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#E8415A" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#1E2D4F" />
          <XAxis dataKey="week" tick={{ fontFamily:'JetBrains Mono', fontSize:11, fill:'#5B7BA8' }} />
          <YAxis tick={{ fontFamily:'JetBrains Mono', fontSize:11, fill:'#5B7BA8' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontFamily:'Space Grotesk', fontSize:'13px' }} />
          <Area type="monotone" dataKey="Pass" stroke="#00C2A8" strokeWidth={2} fill="url(#passGrad)" />
          <Area type="monotone" dataKey="Fail" stroke="#E8415A" strokeWidth={2} fill="url(#failGrad)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
